import type { IOurExperienceItem } from '~/components/pages/directions/our-experience-section/our-experience-section.types'

const OUR_EXPERIENCE_AUDIOGUIDE: IOurExperienceItem[] = [
    {
        title: 'Занимаемся аудиогидами 15&nbsp;лет и&nbsp;знаем про эту сферу всё. Ответим вам на&nbsp;любой вопрос',
        icon: '15 years',
    },
    {
        title: 'Работали более чем с&nbsp;8800 организаций и&nbsp;частных лиц в&nbsp;России и&nbsp;СНГ',
        icon: 'companies',
    },
    {
        title: 'Продали более 40000 единиц оборудования',
        image: '/assets/images/ui/our-experience/jpg-png/audioguides.png',
        image_webp: '/assets/images/ui/our-experience/webp/audioguides.webp',
    },
]

export default OUR_EXPERIENCE_AUDIOGUIDE
